module.exports = __webpack_public_path__ + "img/coloring_logo.c96f7782.png";